import _ from 'underscore';
import i18n from 'l10n';
import $ from "jquery";
import gMaps from "gMaps";
import Handlebars from "handlebars";
import moment from "moment";

const mapTemplate = require("js/templates/contacts.map.hbs");

require('jQuery-QueryBuilder');
require('jQuery-QueryBuilder/dist/i18n/query-builder.el');
require('markerClusterer');

$.datetimepicker.setDateFormatter('moment');
const serverDTFormat = "YYYY-MM-DD HH:mm:ss";
const displayDTFormat = "DD MMM Y HH:mm (Z)";

const compToQueryOperatorHash = {
    '=': 'equal',
    '<': 'less',
    '>': 'greater',
    '>=': 'greater_or_equal',
    '<=': 'less_or_equal',
    '/=': 'not_equal',
    'BTW_E': 'between',
    'NBTW_E': 'not_between',
    'in': 'in',
    'ex': 'not_in',
    'NULL': 'is_null',
    'NOTNULL': 'is_not_null',
    '~=': 'contains',
    '~/=': 'not_contains'
    //todo
};

const queryOperatorToCompHash = _.invert(compToQueryOperatorHash);
const compiledMapTemplate = Handlebars.compile(mapTemplate);

const makeValue = (type, v) => {
    let f;
    if (type === "integer" && typeof v === "string") {
        f = parseInt;
    } else if (type === "double" && typeof v === "string") {
        f = parseFloat;
    } else if (type === "date" && typeof v === "string") {
        f = v => moment(v, displayDTFormat).utc().format(serverDTFormat);
    } else {
        f = _.identity;
    }
    if (v instanceof Array) {
        return _.map(v, f);
    } else {
        return f(v);
    }
};

const valueToString = v => {
    if (v instanceof Array) {
        return _.map(v, valueToString);
    } else if (typeof v === "string") {
        return JSON.stringify(v);
    } else if (typeof v === "number") {
        return `${v}`;
    } else return null;
};

const arrayToSimpleObject = (memo, prop) => Object.assign({[prop]: prop}, memo);

function createFilterFromDescriptor(descriptor) {

    const labelFilter = (descriptor) => {
        if (descriptor.customName) {
            return descriptor.customName;
        } else {
            return i18n.t(`querybuilder.${descriptor.name}`);
        }
    };
    const retObj = {
        id: descriptor.expression,
        label: labelFilter(descriptor),
    };
    switch (descriptor.type) {
        case "Integer":
        case "Long":
            retObj.type = "integer";
            retObj.operators = ['equal', 'not_equal', 'less', 'less_or_equal', 'greater', 'greater_or_equal', 'between', 'not_between'];
            break;
        case "Double":
            retObj.type = "double";
            retObj.validation = {
                min: 0,
                step: 0.01
            };
            retObj.operators = ['equal', 'not_equal', 'less', 'less_or_equal', 'greater', 'greater_or_equal', 'between', 'not_between'];
            break;
        case "String":
            retObj.type = "string";
            retObj.operators = ['equal', 'not_equal', 'contains', 'not_contains', 'is_null', 'is_not_null'];
            break;
        case "Enum":
            retObj.type = "string";
            retObj.input = "checkbox";
            retObj.values = descriptor.values.reduce(arrayToSimpleObject, {});
            retObj.operators = ['equal', 'not_equal', 'is_null', 'is_not_null'];
            break;
        case "Date":
            retObj.type = "date";
            retObj.plugin = 'datetimepicker';
            retObj.operators = ['equal', 'not_equal', 'less', 'less_or_equal', 'greater', 'greater_or_equal', 'is_null', 'is_not_null'];
            retObj.plugin_config = {
                format: displayDTFormat,
                todayBtn: 'linked',
                todayHighlight: true,
                autoclose: true
            };
            break;
        default:
            throw new Error("Missing implementation");
    }
    return retObj;
}

function acceptedDescriptor(descriptor) {
    const arr1 = ["Integer", "Long", "String", "Enum", "Double", "Date"];
    return arr1.includes(descriptor.type);

}

/**
 * Creates the QueryBuilder options hash with given filters
 * @param filters
 * @returns {{lang_code: string, plugins: string[], filters: *, icons: {remove_group: string, add_group: string, remove_rule: string, add_rule: string, error: string}}}
 */
const queryBuilderOptions = (filters) => ({
    icons: {
        add_group: 'fa fa-plus-square',
        add_rule: 'fa fa-plus-circle',
        remove_group: 'fa fa-minus-square',
        remove_rule: 'fa fa-minus-circle',
        error: 'fa fa-exclamation-triangle'
    },
    lang_code: i18n.language,
    plugins: [
        //'sortable',
        // 'filter-description',
        'unique-filter',
        // 'bt-tooltip-errors',
        //'bt-selectpicker',
        'bt-checkbox',
        //                    'invert',
        //                    'not-group'
    ],
    filters
});

function cccHandler(rule, name, {data}) {
    if (data) {
        const container = rule.$el.find('.rule-value-container');
        if (data.length > 0) {
            if (!rule.value) {
                rule.value = data[0].campaignId;
            } else {
                rule.value = parseInt(rule.value);
            }
        }
        data.forEach((e) => {
            const $select = container.find(`select[name=${name}_1]`);
            $select.append(
                $(`<option value=${e.campaignId}>${e.title || i18n.t("message.nonamemessage")}</option>`)
            );
            if (rule.value === e.campaignId) {
                $select.val(rule.value);
            }
        });
    }
}

function groupHandler(rule, name, response) {
    if (response) {
        if (response.length > 0) {
            if (!rule.value) {
                rule.value = response[0].id;
            }
        }

        var $container = rule.$el.find('.rule-value-container');
        const $select = $container.find(`select[name=${name}_1]`);

        response.forEach((e) => {
            $select.append(
                $(`<option value=${e.id}>${e.title}</option>`)
            );
            if (parseInt(rule.value) === e.id) {
                $select.val(rule.value);
            }
        });
    }
}

const campaignStatusIs = 'ACTIVE,COMPLETED,ENDED,INTERRUPTED';

/**
 * Creates the AJAX GET request of Campaign Configuration for given filters
 * @param filters
 * @returns {jQuery|*}
 */
function getConfigWithFilters(filters) {
    return $.ajaxDefaultQ({
        url: '/CampaignCloud/Config/WithFilters',
        type: 'get',
        contentType: 'application/json',
        dataType: 'json',
        data: {
            page: 0,
            per_page: 200,
            filtersMap: JSON.stringify(filters)
        }
    });
}

const predefinedQueryFilters = [
    {
        id: '-birthdayToday',
        label: i18n.t("querybuilder.BIRTHDAYS_TODAY"),
        type: 'string',
        input: function (rule, name) {
            return '<span>the contact</span>';
        },
        validation: {
            allow_empty_value: true,
        },
        operators: ['contains', 'not_contains']
    }, {
        id: '-namedayToday',
        label: i18n.t("querybuilder.NAMEDAY_TODAY"),
        type: 'string',
        input: function (rule, name) {
            return '<span>the contact</span>';
        },
        validation: {
            allow_empty_value: true,
        },
        operators: ['contains', 'not_contains']
    }, {
        id: '-text',
        label: 'Text',
        type: 'string',
        operators: ['contains', 'not_contains']
    }, {
        id: '-engagementMetricBetween',
        label: i18n.t("querybuilder.ENGAGEMENT_METRIC"),
        type: 'double',
        validation: {
            min: 0,
            max: 1
        },
        operators: ['between', 'not_between']
    }, {
        id: '-satisfactionMetricBetween',
        label: i18n.t("querybuilder.SATISFACTION_METRIC"),
        type: 'double',
        validation: {
            min: 0,
            max: 1
        },
        operators: ['between', 'not_between']
    }, {
        id: '-group',
        label: i18n.t("querybuilder.GROUP"),
        type: 'integer',
        operators: ['contains', 'not_contains'],
        input: function (rule, name) {
            var group_id = parseInt(rule.filter.GroupId);

            $.ajaxDefaultQ({
                url: '/CampaignCloud/Group' + (group_id ? `/hasDependecyGroups/${group_id}` : ''),
                type: 'get',
                contentType: 'application/json',
                dataType: 'json'
            }).done(groupHandler.bind(this, rule, name));

            return '<span>the contact</span> : <select name="' + name + '_1"></select>';
        }, valueGetter: function (rule) {
            return rule.$el.find('.rule-value-container select[name$=_1]').val();
        },
    }, {
        id: '-campaign',
        label: i18n.t("querybuilder.CAMPAIGN"),
        type: 'integer',
        operators: ['contains', 'not_contains'],
        input: function (rule, name) {

            getConfigWithFilters({campaignStatusIs}).done(cccHandler.bind(this, rule, name));

            return `<span>the contact</span> : <select name="${name}_1"></select>`;
        }, valueGetter: function (rule) {
            return rule.$el.find('.rule-value-container select[name$=_1]').val();
        },
    }, {
        id: '-survey',
        label: i18n.t("querybuilder.SURVEY"),
        type: 'integer',
        operators: ['contains', 'not_contains'],
        input: function (rule, name) {

            getConfigWithFilters({
                campaignStatusIs,
                multipleCampaignTemplateType: 'TELLODY_SURVEY'
            }).done(cccHandler.bind(this, rule, name));

            return `<span>the contact</span> : <select name="${name}_1"></select>`;
        }, valueGetter: function (rule) {
            return rule.$el.find('.rule-value-container select[name$=_1]').val();
        },
    }, {
        id: '-voucher',
        label: i18n.t("querybuilder.VOUCHER"),
        type: 'integer',
        operators: ['contains', 'not_contains'],
        input: function (rule, name) {

            getConfigWithFilters({
                campaignStatusIs,
                multipleCampaignTemplateType: 'TELLODY_VOUCHER'
            }).done(cccHandler.bind(this, rule, name));

            return `<span>the contact</span> : <select name="${name}_1"></select>`;
        }, valueGetter: function (rule) {
            return rule.$el.find('.rule-value-container select[name$=_1]').val();
        },
    }, {
        id: '-instantWinWinners',
        label: i18n.t("querybuilder.INSTANT_WIN"),
        type: 'integer',
        operators: ['contains', 'not_contains'],
        input: function (rule, name) {

            getConfigWithFilters({
                campaignStatusIs,
                multipleCampaignTemplateType: 'INSTANT_WIN'
            }).done(cccHandler.bind(this, rule, name));

            return `<span>the contact</span> : <select name="${name}_1"></select>`;
        }, valueGetter: function (rule) {
            return rule.$el.find('.rule-value-container select[name$=_1]').val();
        },
    }, {
        id: '-payPalPaymentBuyers',
        label: i18n.t("querybuilder.PAYPAL_PAYMENT"),
        type: 'integer',
        operators: ['contains', 'not_contains'],
        input: function (rule, name) {

            getConfigWithFilters({
                campaignStatusIs,
                multipleCampaignTemplateType: 'PAY_PAL_PAYMENT'
            }).done(cccHandler.bind(this, rule, name));

            return `<span>the contact</span> : <select name="${name}_1"></select>`;
        }, valueGetter: function (rule) {
            return rule.$el.find('.rule-value-container select[name$=_1]').val();
        },
    }, {
        id: '-uurlFollowed',
        label: i18n.t("querybuilder.FOLLOWED_URL"),
        type: 'string',
        operators: ['contains', 'not_contains'],
        input: function (rule, name) {
            var container = rule.$el.find('.rule-value-container');

            getConfigWithFilters({
                campaignStatusIs
            }).done(function (response) {
                if (response) {
                    var qs = response.data;
                    container.find(`select[name=${name}_2]`).append(
                        $(`<option>URL</option>`),
                        $(`<option>TRACK</option>`),
                        $(`<option>OPTOUT</option>`),
                        $(`<option>VOUCHER</option>`),
                        $(`<option>SURVEY</option>`),
                        $(`<option>DL</option>`)
                    );
                    if (qs.length > 0) {
                        if (!rule.value || rule.value.indexOf("null") > -1) {
                            var str1 = qs[0].campaignId.toString();
                            var str2 = 'URL';
                            rule.value = `${str1},${str2}`;
                        }

                    }
                    qs.forEach((e) => {
                        if (e.title === '') {
                            container.find(`select[name=${name}_1]`).append(
                                $(`<option value=${e.campaignId}>${i18n.t("message.nonamemessage")}</option>`)
                            );
                        } else {
                            container.find(`select[name=${name}_1]`).append(
                                $(`<option value=${e.campaignId}>${e.title}</option>`)
                            );
                        }
                        if (rule.value[0] === e.campaignId) {
                            container.find(`select[name=${name}_1]`).val(rule.value[0]);
                            container.find(`select[name=${name}_2]`).val(rule.value[1]);
                        }
                    });
                }
            });
            return '<span>the contact</span> : <select name="' + name + '_1"></select> <select name="' + name + '_2"></select>';
        }, valueGetter: function (rule) {
            return rule.$el.find('.rule-value-container select[name$=_1]').val()
                + ',' + rule.$el.find('.rule-value-container select[name$=_2]').val();
        }
    }, {
        id: '-bounds',
        label: i18n.t("querybuilder.BOUNDS"),
        type: 'string',
        operators: ['contains', 'not_contains'],
        input: function (rule, name) {
            var html = "";
            setTimeout(function () {
                var shrink = function (bounds) {
                    var ne = bounds.getNorthEast();
                    var sw = bounds.getSouthWest();
                    var diagonal = gMaps.geometry.spherical.computeDistanceBetween(ne, sw);
                    var newNe = gMaps.geometry.spherical.computeOffset(ne, diagonal / 12, 225);
                    var newSw = gMaps.geometry.spherical.computeOffset(sw, diagonal / 12, 45);
                    return new gMaps.LatLngBounds(newSw, newNe);
                };

                var map = new gMaps.Map($(rule.$el.find(`.rule-value-container div[id=map-${rule.id}]`))[0], {
                    center: new gMaps.LatLng(44.5403, -78.5463),
                    zoom: 8,
                    mapTypeId: gMaps.MapTypeId.ROADMAP,
                    mapTypeControl: false,
                    scaleControl: true,
                    streetViewControl: false,
                    rotateControl: false
                });


                var viewport_changed = function () {
                    var bounds = map.getBounds();

                    var ne = bounds.getNorthEast();
                    var sw = bounds.getSouthWest();

                    var contentString = `Viewport changed: New south-west corner: ${sw.lat()}, ${sw.lng()}, New north-east corner: ${ne.lat()}, ${ne.lng()}`;

                    console.log(contentString);
                };

                map.addListener('bounds_changed', _.debounce(viewport_changed, 1000));

                var geocoder = new gMaps.Geocoder();


                var startSelectButton = rule.$el.find(`.rule-value-container a[id=start-select-${rule.id}]`);
                var endSelectButton = rule.$el.find(`.rule-value-container a[id=end-select-${rule.id}]`);

                const handleLocationError = (browserHasGeolocation, infoWindow, pos) => {
                    infoWindow.setPosition(pos);
                    infoWindow.setContent(browserHasGeolocation ?
                        i18n.t("map.geoservicefailed") :
                        i18n.t("map.geoserviceisnotsupported"));
                };

                //    if (!self.box || self.box === "none") {
                $.ajaxDefaultQ({
                    url: "/CampaignCloud/Subscriber/getBounds",
                    type: 'GET',
                    contentType: "application/json",
                    dataType: 'json'
                }).done(function (data) {
                    console.info(data);

                    if (data.south !== 0 ||
                        data.north !== 0 ||
                        data.east !== 0 ||
                        data.west !== 0) {
                        if (data.south === data.north && data.west === data.east) {
                            var latLng = new gMaps.LatLng(data.south, data.west);
                            map.panTo(latLng);
                        } else {
                            var southWest = new gMaps.LatLng(data.south, data.west);
                            var northEast = new gMaps.LatLng(data.north, data.east);
                            var bounds = new gMaps.LatLngBounds(southWest, northEast);
                            map.fitBounds(bounds);
                        }
                    } else {
                        var infoWindow = new gMaps.InfoWindow({map: map});
                        if (navigator.geolocation) {
                            navigator.geolocation.getCurrentPosition(function (position) {
                                var pos = {
                                    lat: position.coords.latitude,
                                    lng: position.coords.longitude
                                };

                                infoWindow.setPosition(pos);
                                infoWindow.setContent(i18n.t("map.locationfound"));
                                map.setCenter(pos);
                            }, function () {
                                handleLocationError(true, infoWindow, map.getCenter());
                            });
                        } else {
                            handleLocationError(false, infoWindow, map.getCenter());
                        }
                    }
                }).fail(function (data) {
                    console.error(data);
                });
                //            }

                var startSelectFunction = function (bounds) {
                    // Define the rectangle and set its editable property to true.
                    var rectangle = new gMaps.Rectangle({
                        bounds: bounds,
                        editable: true,
                        draggable: true
                    });

                    rectangle.setMap(map);

                    var bounds_changed = function () {
                        var bounds = rectangle.getBounds();
                        var ne = bounds.getNorthEast();
                        var sw = bounds.getSouthWest();
                        var que = 'q:in bounds(' + sw.lat() + ',' + sw.lng() + ',' + ne.lat() + ',' + ne.lng() + ')';
                        var south = sw.lat();
                        var west = sw.lng();
                        var north = ne.lat();
                        var east = ne.lat();
                        rule.$el.find('.rule-value-container input[name=text1]').val(south);
                        rule.$el.find('.rule-value-container input[name=text2]').val(west);
                        rule.$el.find('.rule-value-container input[name=text3]').val(north);
                        rule.$el.find('.rule-value-container input[name=text4]').val(east);
                        var valueCriterion = que.substring(12, que.length - 1);
                        var contentString = 'Rectangle moved: ' +
                            'New south-west corner: ' + sw.lat() + ', ' + sw.lng() +
                            ', New north-east corner: ' + ne.lat() + ', ' + ne.lng();

                        console.log(contentString);
                        rule.value = valueCriterion;
                    };

                    // Add an event listener on the rectangle.
                    rectangle.addListener('bounds_changed', _.debounce(bounds_changed, 1000));
                    bounds_changed();

                    startSelectButton.hide();
                    endSelectButton.click(function () {
                        console.log('End of selection');
                        rectangle.setMap(null);
                        rectangle = null;
                        startSelectButton.show();
                        endSelectButton.hide();
                        endSelectButton.off("click");
                        $('#contacts-selected').text(i18n.t("map.contactsselected", {count: 0}));
                        $('#buttons').hide();
                    });
                    endSelectButton.show();
                };

                startSelectButton.click(function () {
                    startSelectFunction(shrink(map.getBounds()));
                });

                var input = rule.$el.find(`.rule-value-container input[class=searchbox_searchcountry-${rule.id}]`);

                var marker = null;

                input.keyup(function (e) {
                    if (e.keyCode === 13) {
                        var searchText = input.val();
                        geocoder.geocode({'address': searchText}, function (results, status) {
                            console.log(results);
                            if (status === gMaps.GeocoderStatus.OK) {
                                map.panTo(results[0].geometry.location);
                                if (marker) {
                                    marker.setMap(null);
                                }
                                marker = new gMaps.Marker({
                                    map: map,
                                    title: searchText,
                                    icon: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
                                    position: results[0].geometry.location
                                });
                            } else {
                                dhtmlx.alert(i18n.t("map.geocodefail"));
                            }
                        });
                    }
                });


            }, 1000);
            html += compiledMapTemplate(rule);

            return html;

        }, valueGetter: function (rule) {
            return rule.$el.find('.rule-value-container input[name=text1]').val()
                + ',' + rule.$el.find('.rule-value-container input[name=text2]').val()
                + ',' + rule.$el.find('.rule-value-container input[name=text3]').val()
                + ',' + rule.$el.find('.rule-value-container input[name=text4]').val();

        }
    }];

const fetchCriteria = _.once(() => $.get("/CampaignCloud/api/availableCriteria"));

export default {
    /**
     * @type {{lang_code: string, plugins: string[], filters: *[], icons: {remove_group: string, add_group: string, remove_rule: string, add_rule: string, error: string}}}
     * */
    queryBuilderOptions: {},
    initFilters: async function (groupId) { //todo: when going to that view from inside the same page, a race condition occurs and nothing is rendered
        const availableCriteria = await fetchCriteria();
        const queryFilters = availableCriteria.filter(acceptedDescriptor).map(createFilterFromDescriptor).concat(...predefinedQueryFilters);
        this.queryFilters = queryFilters;
        this.queryBuilderOptions = queryBuilderOptions(queryFilters);
        let filtersQuery = this.queryBuilderOptions.filters;
        if (groupId) {
            filtersQuery.forEach((e) => {
                if (e.id === "-group") {
                    const index = filtersQuery.findIndex(d => d.id === "-group");
                    filtersQuery[index].GroupId = groupId;
                }
            });
        }
        return queryFilters;
    },
    /**
     * Takes a query builder rule set and generates an AST
     * @param r (rules) the rule set
     * @returns {{comp: *, r: null, s: number, f: *}|{args: *[], positive: boolean, m: (*|string)}|*}
     */
    rulesToParsedQuery: function (r) {
        if (r.condition) {
            let innerParsedQueries = _.map(r.rules, r => this.rulesToParsedQuery(r));
            return _.reduce(innerParsedQueries, (f, s) => ({
                op: r.condition.toLowerCase(),
                f: f,
                s: s
            }));
        } else if (r.id.startsWith('-')) {
            return {
                m: r.id.substr(1),
                positive: r.operator === 'contains' || r.operator === 'between',
                args: r.value instanceof Array ? r.value : [r.value]
            };
        } else {
            var value = makeValue(r.type, r.value);
            return {
                comp: this.queryOperatorToComp(r.operator),
                f: r.id,
                s: value,
                r: null
            };
        }
    },

    /**
     * This function takes the AST and converts it into a query expression recursively
     * @param q {{comp: *, r: null, s: number, f: *}|{args: *[], positive: boolean, m: (*|string)}|*} (query) the query (or subquery) to make into an expression string
     * @param i {boolean} (immediate) indicates if the execution of this subquery is prioritized .
     * @returns {string|*|string}
     */
    parsedQueryToQuery: function (q, i) {
        // Case: simple comparison
        if (q.comp && !q.r) {
            if (q.comp === 'in' || q.comp === 'ex') {
                let comp = q.comp === "in" ? "in" : "not in";
                let values = q.s.join(', ');
                return `${q.f} ${comp} {${values}}`;
            } else if (q.comp === 'NULL' || q.comp === 'NOTNULL') {
                let comp = q.comp === "NULL" ? "not" : "";
                return ` ${comp} ${q.f}`;
            } else if (q.comp === 'BTW_E' || q.comp === 'NBTW_E') {
                let comp = q.comp === "BTW_E" ? "in" : "not in";
                let values = q.s.join('..');
                return `${q.f} ${comp} [${values}]`;
            } else {
                let value = valueToString(q.s);
                return `${q.f} ${q.comp} ${value}`;
            }
            // Case: boolean op
        } else if (q.op) {
            const isAnd = q.op === 'and';
            let f = this.parsedQueryToQuery(q.f, isAnd);
            let s = this.parsedQueryToQuery(q.s, isAnd);
            let op = isAnd ? '/\\' : '\\/';
            const opExp = `${f} ${op} ${s}`;
            //if the previous operation is immediate and the current one isn't, parenthesize.
            return i && !isAnd ? `(${opExp})` : opExp;
        } else if (q.m) {
            let pos = q.positive === true ? "in" : "not in";
            if (q.args) {
                if (!isNaN(parseInt(q.args[0]))) {
                    if (isNaN(q.args[0])) {
                        const temp = q.args[0].split(",");
                        if (temp.length === 2) {
                            return this.calcMembershipCriterionUrlFollowed(q, pos, temp);
                        } else if (temp.length === 4) {
                            return this.calcMembershipCriterionBounds(q, pos, temp);
                        }
                    }
                    return this.calcMembershipCriterionInt(q, pos);
                } else {
                    return this.calcMembershipCriterionText(q, pos);
                }
            } else return "**ERROR**";
        } else {
            return "**ERROR**";
        }
    },

    compToQueryOperator: function (comp) {
        return compToQueryOperatorHash[comp];
    },

    queryOperatorToComp: function (op) {
        return queryOperatorToCompHash[op];
    },

    parsedQueryToRules: function (q) {
        let r = this.parsedQueryToRulesInner(q);
        return r && (!r.rules || r.rules.length === 0) ? [r] : r;
    },

    parsedQueryToRulesInner: function ({comp, r, f, op, m, s, arg, positive}) {

        const parseVal = (id, val) => {
            const filter = this.queryBuilderOptions.filters.find(f => f.id === id);
            if (filter.type === "date")
                return moment(val, serverDTFormat).local().format(displayDTFormat);
            else return val;
        };
        // Case: simple comparison
        if (comp && !r) {
            return {
                id: f,
                operator: this.compToQueryOperator(comp),
                value: parseVal(f, s)
            };
            // Case: boolean op
        } else if (op) {
            let ff = this.parsedQueryToRulesInner(f);
            let ss = this.parsedQueryToRulesInner(s);
            if (!f || !s) {
                return null;
            }
            let filterOp = op.toUpperCase();
            if (filterOp === ss.condition) {
                return {
                    condition: filterOp,
                    rules: [ff, ...ss.rules]
                };
            } else {
                return {
                    condition: filterOp,
                    rules: [ff, ss]
                };
            }
        } else if (m) {
            const pfId = `-${m}`;
            return {
                id: pfId,
                operator: positive ? 'contains' : 'not_contains',
                value: parseVal(pfId, arg)
            };
        } else {
            return null;
        }
    },

    calcMembershipCriterionInt: function (q, pos) {
        let values = q.args.join(',');
        return `${pos} ${q.m}(${values})`;
    },

    calcMembershipCriterionText: function (q, pos) {
        let values = q.args.map(valueToString).join(',');
        return `${pos} ${q.m}(${values})`;
    },

    calcMembershipCriterionUrlFollowed: function (q, pos, temp) {
        let v = parseInt(q.args);
        let temp2 = temp.map(valueToString)[1];
        return `${pos} ${q.m}(${v}, ${temp2})`;
    },

    calcMembershipCriterionBounds: function (q, pos, temp) {
        const bound1 = parseFloat(temp[0]);
        const bound2 = parseFloat(temp[1]);
        const bound3 = parseFloat(temp[2]);
        const bound4 = parseFloat(temp[3]);
        return `${pos} ${q.m}(${bound1},${bound2},${bound3},${bound4})`;
    }
};